var React = require('react');

function KokPentry (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M36.5 51c0-1.4 1.1-2.5 2.5-2.5h91c1.4 0 2.5 1.1 2.5 2.5v65a27.5 27.5 0 0 1-27.5 27.5H64A27.5 27.5 0 0 1 36.5 116V51Z","stroke":"#000","strokeWidth":"5","key":0}),React.createElement("path",{"d":"M135 118.5a2.5 2.5 0 0 1-2.5-2.5V69c0-1.4 1.1-2.5 2.5-2.5h4.5a26 26 0 0 1 0 52H135Z","stroke":"#000","strokeWidth":"5","key":1}),React.createElement("path",{"d":"M134 108.5c-.8 0-1.5-.7-1.5-1.5V78c0-.8.7-1.5 1.5-1.5h5.5a16 16 0 1 1 0 32H134Z","stroke":"#000","strokeWidth":"5","key":2})]);
}

KokPentry.defaultProps = {"viewBox":"0 0 191 191","width":"191","height":"191","fill":"none"};

module.exports = KokPentry;

KokPentry.default = KokPentry;
